import { routerRedux } from 'dva/router'
import { stringify } from 'qs'
import { accountLogin, fetchUserInfo } from '@/services/api'
import { getPageQuery, getQueryValue } from '@/utils/utils'

export default {
  namespace: 'login',

  state: {
    status: null, // success fail
    autoLoged: false,
  },

  effects: {
    *login({ payload }, { call, put }) {
      const res = yield call(accountLogin, payload)
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: 'success',
        },
      })

      window.token = res.token // 将token设为全局变量
      // Login successfully
      // 保存用户信息
      const userinfo = yield call(fetchUserInfo)
      yield put({
        type: 'user/changeUser',
        payload: userinfo,
      })

      if (payload.autoLogin) {
        // 勾选了自动登录，缓存 token
        localStorage.setItem('token', res.token)
      }

      const urlParams = new URL(window.location.href)
      const params = getPageQuery()
      // let { redirect } = params
      // if (redirect) {
      //   const redirectUrlParams = new URL(redirect)
      //   if (redirectUrlParams.origin === urlParams.origin) {
      //     redirect = redirect.substr(urlParams.origin.length)
      //     if (redirect.match(/^\/.*#/)) {
      //       redirect = redirect.substr(redirect.indexOf('#') + 1)
      //     }
      //   } else {
      //     redirect = null
      //   }
      // }
      // yield put(routerRedux.replace(redirect || '/'))
      yield put(routerRedux.replace('/'))
    },

    *doAutoLogin(_, { call, put }) {
      // 执行自动登录，校验 token
      const uniToken = getQueryValue('unitoken')
      let token
      if (uniToken) {
        token = uniToken
        localStorage.setItem('token', uniToken)
      } else {
        token = localStorage.getItem('token')
      }

      try {
        if (token) {
          window.token = token
          const userinfo = yield call(fetchUserInfo)
          yield put({
            type: 'changeLoginStatus',
            payload: {
              status: 'success',
            },
          })
          // 保存用户信息
          yield put({
            type: 'user/changeUser',
            payload: userinfo,
          })
        }
      } finally {
        yield put({
          type: 'changeAutoLoged',
          payload: true,
        })
      }
    },

    *logout(_, { put }) {
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: null,
        },
      })
      window.token = null
      localStorage.removeItem('token')
      const { redirect } = getPageQuery()
      // redirect
      if (window.location.pathname !== '/user/login' && !redirect) {
        yield put(
          routerRedux.replace({
            pathname: '/user/login',
            search: stringify({
              redirect: window.location.href,
            }),
          }),
        )
      }
    },
  },

  reducers: {
    changeLoginStatus(state, { payload }) {
      const { status } = payload
      return {
        ...state,
        status,
      }
    },
    changeAutoLoged(state, { payload }) {
      return {
        ...state,
        autoLoged: payload,
      }
    },
  },
}
